import React, { useState, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { AppHeader } from '../../shared/components/AppComponents';
import GrapeEscapeHome from './GrapeEscapeHome';
import CellarView from './CellarView';
import TastingView from './TastingView';
import AchievementsView from './AchievementsView';
import WsetCourse from './WsetCourse';
import BordeauxDeals from './BordeauxDeals';
import './GrapeEscape.css';

function GrapeEscape({ user }) {
  const { instance } = useMsal();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('home');
  const [message, setMessage] = useState(null);

  const showMessage = useCallback((text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 4000);
  }, []);

  const tabs = [
    { id: 'home', label: '🏠', title: t('grapeEscape.tabs.home', 'Home') },
    { id: 'cellar', label: '🍾', title: t('grapeEscape.tabs.cellar', 'Cellar') },
    { id: 'taste', label: '📝', title: t('grapeEscape.tabs.taste', 'Taste') },
    { id: 'wset', label: '🎓', title: t('grapeEscape.tabs.wset', 'WSET') },
    { id: 'deals', label: '🏷️', title: t('grapeEscape.tabs.deals', 'Deals') },
    { id: 'achievements', label: '🏆', title: t('grapeEscape.tabs.achievements', 'Achievements') },
  ];

  return (
    <div className="grape-escape">
      <AppHeader title={t('grapeEscape.title', 'Grape Escape')} user={user} />

      {message && (
        <div className={`ge-message ge-message-${message.type}`} role="status" aria-live="polite">
          {message.text}
        </div>
      )}

      <div className="ge-tabs" role="tablist" aria-label="Wine cellar sections">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`ge-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
          >
            <span className="ge-tab-icon">{tab.label}</span>
            <span className="ge-tab-label">{tab.title}</span>
          </button>
        ))}
      </div>

      {activeTab === 'home' && (
        <GrapeEscapeHome instance={instance} showMessage={showMessage} onNavigate={setActiveTab} />
      )}
      {activeTab === 'cellar' && (
        <CellarView instance={instance} showMessage={showMessage} />
      )}
      {activeTab === 'taste' && (
        <TastingView instance={instance} showMessage={showMessage} />
      )}
      {activeTab === 'wset' && <WsetCourse />}
      {activeTab === 'deals' && <BordeauxDeals />}
      {activeTab === 'achievements' && (
        <AchievementsView instance={instance} />
      )}
    </div>
  );
}

export default GrapeEscape;
